import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  isNotEmptyArray,
  isNotNullAndUndefined,
  isObjectEmpty,
} from 'src/app/utilities/utils';
import { ToastController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { AlertModalPage } from 'src/app/components/alert-modal/alert-modal.page';
import * as moment from 'moment';
import { UserAuthService } from '../user-auth/user-auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from '../backend-call/backend-call.service';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { ToastService } from 'src/app/services/toast.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GraphService } from '../graph/graph.service';
import { AppConstants } from 'src/app/utilities/constant';
@Injectable({
  providedIn: 'root',
})
export class ShareValuesService {
  
  public viewSelectedRoadmap: any = {};
  public hazardDropdownData$ = new BehaviorSubject<any[]>([]);
  globalSearchInput: string;
  expanded = false;
  public showExitOnEditorTemplate = true;
  public isGridDataLoading = true;
  extendedRoadMapPayload: any = {};
  listOfServices: any = [];
  finalNotification = [];
  public notifications$ = new BehaviorSubject<any[]>([]);
  customersInfo = new BehaviorSubject(null);
  eachSelectedContactDetails: any;
  offerDetailsContact_id: string;
  isFourEyeQualityCheckRequested = false;
  selectedRoadmapsList = [];
  selectedServiceRoadmapsList = [];
  selectedOpporData: any;
  private roadMapStatusLists = [];
  viewOfferListOfServices: any = [];
  // PLR Values
  sValue = '';
  fValue = '';
  pValue = '';
  // Country Values
  public countryData: any;
  public contactType: any;
  public countryList: any;
  // groupsArray = [];
  searchedProjectLists = [];
    public showHazardDetailsState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public dashboardCustomizationValueSubmitted: BehaviorSubject<{}> =
    new BehaviorSubject<{}>({
      isValueChanged: true,
    });

  weightagesList = [
    { label: 'Almost Impossible (possible under extreme circumstances) (0.033)', value: '0.033', id: '1' },
    { label: 'Highly Unlikely (though conceivable) (0.5)', value: '0.5', id: '2' },
    { label: 'Unlikely (but could occur) (1)', value: '1', id: '3' },
    { label: 'Possible (but unusual) (2)', value: '2', id: '4' },
    { label: 'Even Chance (could happen) (5)', value: '5', id: '5' },
    { label: 'Probable (not surprised) (8)', value: '8', id: '6' },
    { label: 'Likely (to be expected) (10)', value: '10', id: '7' },
    { label: 'Certain (no doubt) (15)', value: '15', id: '8' }
  ];

  weightagesListFrenchLang = [
    { label: 'Presque impossible (possible dans des circonstances extrêmes) (0.033)', value: '0.033', id: '1' },
    { label: 'Très improbable (bien que concevable) (0.5)', value: '0.5', id: '2' },
    { label: 'Improbable (mais pourrait se produire) (1)', value: '1', id: '3' },
    { label: 'Possible (mais inhabituel) (2)', value: '2', id: '4' },
    { label: 'Chance égale (pourrait arriver) (5)', value: '5', id: '5' },
    { label: 'Probable (pas surprenant) (8)', value: '8', id: '6' },
    { label: 'Probable (à prévoir) (10)', value: '10', id: '7' },
    { label: 'Certain (sans aucun doute) (15)', value: '15', id: '8' }
  ];

  weightagesListItalianLang = [
    { label: 'Quasi impossibile (possibile in circostanze estreme) (0.033)', value: '0.033', id: '1' },
    { label: 'Altamente improbabile (sebbene concepibile) (0.5)', value: '0.5', id: '2' },
    { label: 'Improbabile (ma potrebbe accadere) (1)', value: '1', id: '3' },
    { label: 'Possibile (ma insolito) (2)', value: '2', id: '4' },
    { label: 'Probabilità pari (potrebbe accadere) (5)', value: '5', id: '5' },
    { label: 'Probabile (non sorprendente) (8)', value: '8', id: '6' },
    { label: 'Probabile (atteso) (10)', value: '10', id: '7' },
    { label: 'Certo (senza dubbio) (15)', value: '15', id: '8' }
  ];

  weightagesListGermanLng = [
    { label: 'Beinahe unmöglich (nur unter extremen Umständen möglich) (0.033)', value: '0.033', id: '1' },
    { label: 'Sehr unwahrscheinlich (wenn auch vorstellbar) (0.5)', value: '0.5', id: '2' },
    { label: 'Unwahrscheinlich (aber könnte passieren) (1)', value: '1', id: '3' },
    { label: 'Möglich (aber ungewöhnlich) (2)', value: '2', id: '4' },
    { label: 'Gleiche Chance (könnte passieren) (5)', value: '5', id: '5' },
    { label: 'Wahrscheinlich (nicht überraschend) (8)', value: '8', id: '6' },
    { label: 'Wahrscheinlich (zu erwarten) (10)', value: '10', id: '7' },
    { label: 'Sicher (kein Zweifel) (15)', value: '15', id: '8' }
  ];

  weightagesListSpanishLang=[
    { label: 'Casi imposible (posible en circunstancias extremas) (0.033)', value: '0.033', id: '1' },
    { label: 'Muy poco probable (aunque concebible) (0.5)', value: '0.5', id: '2' },
    { label: 'Poco probable (pero podría ocurrir) (1)', value: '1', id: '3' },
    { label: 'Posible (pero inusual) (2)', value: '2', id: '4' },
    { label: 'Igual probabilidad (podría ocurrir) (5)', value: '5', id: '5' },
    { label: 'Probable (no sorprende) (8)', value: '8', id: '6' },
    { label: 'Probable (esperado) (10)', value: '10', id: '7' },
    { label: 'Cierto (sin duda) (15)', value: '15', id: '8' }
  ];

  weightagesListPotugueseLang=[
    { label: 'Quase impossível (possível em circunstâncias extremas) (0.033)', value: '0.033', id: '1' },
    { label: 'Altamente improvável (ainda que concebível) (0.5)', value: '0.5', id: '2' },
    { label: 'Improvável (mas pode ocorrer) (1)', value: '1', id: '3' },
    { label: 'Possível (mas incomum) (2)', value: '2', id: '4' },
    { label: 'Probabilidade igual (poderia acontecer) (5)', value: '5', id: '5' },
    { label: 'Provável (não surpreende) (8)', value: '8', id: '6' },
    { label: 'Provável (esperado) (10)', value: '10', id: '7' },
    { label: 'Certo (sem dúvida) (15)', value: '15', id: '8' }
  ];

  weightagesListChineseLang = [
    { label: '几乎不可能（仅在极端情况下可能） (0.033)', value: '0.033', id: '1' },
    { label: '极不可能（虽可设想） (0.5)', value: '0.5', id: '2' },
    { label: '不太可能（但可能发生） (1)', value: '1', id: '3' },
    { label: '可能（但不常见） (2)', value: '2', id: '4' },
    { label: '概率相当（可能发生） (5)', value: '5', id: '5' },
    { label: '很可能（并不意外） (8)', value: '8', id: '6' },
    { label: '可能性高（可预期） (10)', value: '10', id: '7' },
    { label: '确定（毫无疑问） (15)', value: '15', id: '8' }
  ];

  weightagesListPolishLang = [
    { label: 'Prawie niemożliwe (możliwe tylko w skrajnych okolicznościach) (0.033)', value: '0.033', id: '1' },
    { label: 'Bardzo mało prawdopodobne (choć możliwe do wyobrażenia) (0.5)', value: '0.5', id: '2' },
    { label: 'Mało prawdopodobne (ale może wystąpić) (1)', value: '1', id: '3' },
    { label: 'Możliwe (ale nietypowe) (2)', value: '2', id: '4' },
    { label: 'Równa szansa (może się zdarzyć) (5)', value: '5', id: '5' },
    { label: 'Prawdopodobne (nie byłoby zaskoczeniem) (8)', value: '8', id: '6' },
    { label: 'Bardzo prawdopodobne (należy się spodziewać) (10)', value: '10', id: '7' },
    { label: 'Pewne (bez wątpienia) (15)', value: '15', id: '8' }
  ];

  weightagesListDutchLang = [
    { label: 'Bijna onmogelijk (alleen mogelijk onder extreme omstandigheden) (0.033)', value: '0.033', id: '1' },
    { label: 'Zeer onwaarschijnlijk (hoewel voorstelbaar) (0.5)', value: '0.5', id: '2' },
    { label: 'Onwaarschijnlijk (maar het kan gebeuren) (1)', value: '1', id: '3' },
    { label: 'Mogelijk (maar ongebruikelijk) (2)', value: '2', id: '4' },
    { label: 'Evenveel kans (kan gebeuren) (5)', value: '5', id: '5' },
    { label: 'Waarschijnlijk (niet verrassend) (8)', value: '8', id: '6' },
    { label: 'Waarschijnlijk (te verwachten) (10)', value: '10', id: '7' },
    { label: 'Zeker (geen twijfel) (15)', value: '15', id: '8' }
  ];

  weightagesListTurkishLang = [
    { label: 'Neredeyse imkansız (yalnızca aşırı koşullarda mümkün) (0.033)', value: '0.033', id: '1' },
    { label: 'Oldukça düşük olasılık (yine de düşünülebilir) (0.5)', value: '0.5', id: '2' },
    { label: 'Düşük olasılık (ama meydana gelebilir) (1)', value: '1', id: '3' },
    { label: 'Mümkün (ancak alışılmadık) (2)', value: '2', id: '4' },
    { label: 'Eşit olasılık (olabilir) (5)', value: '5', id: '5' },
    { label: 'Muhtemel (şaşırtıcı değil) (8)', value: '8', id: '6' },
    { label: 'Büyük olasılıkla (beklenen) (10)', value: '10', id: '7' },
    { label: 'Kesin (şüphe yok) (15)', value: '15', id: '8' }
  ];

  weightagesListKoreanLang = [
    { label: '거의 불가능함 (극한 상황에서만 가능) (0.033)', value: '0.033', id: '1' },
    { label: '매우 가능성 낮음 (상상은 가능함) (0.5)', value: '0.5', id: '2' },
    { label: '가능성 낮음 (하지만 발생할 수 있음) (1)', value: '1', id: '3' },
    { label: '가능함 (하지만 드묾) (2)', value: '2', id: '4' },
    { label: '반반의 가능성 (일어날 수 있음) (5)', value: '5', id: '5' },
    { label: '상당히 가능함 (놀랍지 않음) (8)', value: '8', id: '6' },
    { label: '높은 가능성 (예상됨) (10)', value: '10', id: '7' },
    { label: '확실함 (의심 없음) (15)', value: '15', id: '8' }
  ];

  weightagesListVietnameseLang = [
    { label: 'Gần như không thể (chỉ có thể trong hoàn cảnh cực đoan) (0.033)', value: '0.033', id: '1' },
    { label: 'Rất khó xảy ra (dù vẫn có thể hình dung) (0.5)', value: '0.5', id: '2' },
    { label: 'Khó xảy ra (nhưng có thể xảy ra) (1)', value: '1', id: '3' },
    { label: 'Có thể xảy ra (nhưng không thường gặp) (2)', value: '2', id: '4' },
    { label: 'Khả năng ngang nhau (có thể xảy ra) (5)', value: '5', id: '5' },
    { label: 'Có khả năng cao (không bất ngờ) (8)', value: '8', id: '6' },
    { label: 'Rất có thể xảy ra (được dự đoán) (10)', value: '10', id: '7' },
    { label: 'Chắc chắn (không nghi ngờ) (15)', value: '15', id: '8' }
  ];

  weightagesListThaiLang = [
    { label: 'แทบเป็นไปไม่ได้ (เป็นไปได้เฉพาะในสถานการณ์รุนแรงมาก) (0.033)', value: '0.033', id: '1' },
    { label: 'ไม่น่าเป็นไปได้อย่างมาก (แม้ยังพอนึกภาพได้) (0.5)', value: '0.5', id: '2' },
    { label: 'ไม่น่าเป็นไปได้ (แต่อาจเกิดขึ้นได้) (1)', value: '1', id: '3' },
    { label: 'เป็นไปได้ (แต่ไม่ปกติ) (2)', value: '2', id: '4' },
    { label: 'โอกาสพอๆ กัน (อาจเกิดขึ้นได้) (5)', value: '5', id: '5' },
    { label: 'มีแนวโน้มสูง (ไม่ใช่เรื่องน่าแปลกใจ) (8)', value: '8', id: '6' },
    { label: 'น่าจะเกิดขึ้น (คาดหมายได้) (10)', value: '10', id: '7' },
    { label: 'แน่นอน (ไม่ต้องสงสัย) (15)', value: '15', id: '8' }
  ];

  weightagesListDanishLang = [
    { label: 'Næsten umuligt (kun muligt under ekstreme omstændigheder) (0.033)', value: '0.033', id: '1' },
    { label: 'Meget usandsynligt (selvom det kan forestilles) (0.5)', value: '0.5', id: '2' },
    { label: 'Usandsynligt (men det kan ske) (1)', value: '1', id: '3' },
    { label: 'Muligt (men usædvanligt) (2)', value: '2', id: '4' },
    { label: 'Lige stor chance (kan ske) (5)', value: '5', id: '5' },
    { label: 'Sandsynligt (ikke overraskende) (8)', value: '8', id: '6' },
    { label: 'Sandsynligt (forventes) (10)', value: '10', id: '7' },
    { label: 'Sikkert (ingen tvivl) (15)', value: '15', id: '8' }
  ];

  weightagesListSwedishLang = [
    { label: 'Nästan omöjligt (möjligt endast under extrema omständigheter) (0.033)', value: '0.033', id: '1' },
    { label: 'Mycket osannolikt (även om det är tänkbart) (0.5)', value: '0.5', id: '2' },
    { label: 'Osannolikt (men kan inträffa) (1)', value: '1', id: '3' },
    { label: 'Möjligt (men ovanligt) (2)', value: '2', id: '4' },
    { label: 'Lika stor chans (kan hända) (5)', value: '5', id: '5' },
    { label: 'Sannolikt (inte överraskande) (8)', value: '8', id: '6' },
    { label: 'Troligt (förväntat) (10)', value: '10', id: '7' },
    { label: 'Säkert (utan tvivel) (15)', value: '15', id: '8' }
  ];


  FEweightagesList: any[] = [
    { label: 'Annually (0.5)', value: '0.5', id: '1' },
    { label: 'Monthly (1)', value: '1', id: '2' },
    { label: 'Weekly (1.5)', value: '1.5', id: '3' },
    { label: 'Daily (2.5)', value: '2.5', id: '4' },
    { label: 'Hourly (4)', value: '4', id: '5' },
    { label: 'Constantly (5)', value: '5', id: '6' }
  ];

  FEweightagesGermanLng: any[] = [
    { label: 'Jährlich (0,5)', value: '0.5', id: '1' },
    { label: 'Monatlich (1)', value: '1', id: '2' },
    { label: 'Wöchentlich (1,5)', value: '1.5', id: '3' },
    { label: 'Täglich (2,5)', value: '2.5', id: '4' },
    { label: 'Stündlich (4)', value: '4', id: '5' },
    { label: 'Dauerhaft (5)', value: '5', id: '6' }
  ];

  FEweightagesSpanishLang: any[] = [
    { label: 'Anualmente (0.5)', value: '0.5', id: '1' },
    { label: 'Mensualmente (1)', value: '1', id: '2' },
    { label: 'Semanalmente (1.5)', value: '1.5', id: '3' },
    { label: 'Diariamente (2.5)', value: '2.5', id: '4' },
    { label: 'Cada hora (4)', value: '4', id: '5' },
    { label: 'Constantemente (5)', value: '5', id: '6' }
  ];

  FEweightagesPortugueseLang: any[] = [
    { label: 'Anualmente (0.5)', value: '0.5', id: '1' },
    { label: 'Mensalmente (1)', value: '1', id: '2' },
    { label: 'Semanalmente (1.5)', value: '1.5', id: '3' },
    { label: 'Diariamente (2.5)', value: '2.5', id: '4' },
    { label: 'De hora em hora (4)', value: '4', id: '5' },
    { label: 'Constantemente (5)', value: '5', id: '6' }
  ];

  FEweightagesFrenchLang: any[] = [
    { label: 'Annuellement (0,5)', value: '0.5', id: '1' },
    { label: 'Mensuellement (1)', value: '1', id: '2' },
    { label: 'Hebdomadairement (1,5)', value: '1.5', id: '3' },
    { label: 'Quotidiennement (2,5)', value: '2.5', id: '4' },
    { label: 'Toutes les heures (4)', value: '4', id: '5' },
    { label: 'Constamment (5)', value: '5', id: '6' }
  ];

  FEweightagesItalianLang: any[] = [
    { label: 'Annualmente (0,5)', value: '0.5', id: '1' },
    { label: 'Mensilmente (1)', value: '1', id: '2' },
    { label: 'Settimanalmente (1,5)', value: '1.5', id: '3' },
    { label: 'Quotidianamente (2,5)', value: '2.5', id: '4' },
    { label: 'Ogni ora (4)', value: '4', id: '5' },
    { label: 'Costantemente (5)', value: '5', id: '6' }
  ];

  FEweightagesChineseLang: any[] = [
    { label: '每年 (0.5)', value: '0.5', id: '1' },
    { label: '每月 (1)', value: '1', id: '2' },
    { label: '每周 (1.5)', value: '1.5', id: '3' },
    { label: '每天 (2.5)', value: '2.5', id: '4' },
    { label: '每小时 (4)', value: '4', id: '5' },
    { label: '持续不断 (5)', value: '5', id: '6' }
  ];

  FEweightagesPolishLang: any[] = [
    { label: 'Corocznie (0.5)', value: '0.5', id: '1' },
    { label: 'Co miesiąc (1)', value: '1', id: '2' },
    { label: 'Co tydzień (1.5)', value: '1.5', id: '3' },
    { label: 'Codziennie (2.5)', value: '2.5', id: '4' },
    { label: 'Co godzinę (4)', value: '4', id: '5' },
    { label: 'Stale (5)', value: '5', id: '6' }
  ];

  FEweightagesDutchLang: any[] = [
    { label: 'Jaarlijks (0.5)', value: '0.5', id: '1' },
    { label: 'Maandelijks (1)', value: '1', id: '2' },
    { label: 'Wekelijks (1.5)', value: '1.5', id: '3' },
    { label: 'Dagelijks (2.5)', value: '2.5', id: '4' },
    { label: 'Elk uur (4)', value: '4', id: '5' },
    { label: 'Voortdurend (5)', value: '5', id: '6' }
  ];

  FEweightagesTurkishLang: any[] = [
    { label: 'Yıllık (0.5)', value: '0.5', id: '1' },
    { label: 'Aylık (1)', value: '1', id: '2' },
    { label: 'Haftalık (1.5)', value: '1.5', id: '3' },
    { label: 'Günlük (2.5)', value: '2.5', id: '4' },
    { label: 'Saatlik (4)', value: '4', id: '5' },
    { label: 'Sürekli (5)', value: '5', id: '6' }
  ];

  FEweightagesKoreanLang: any[] = [
    { label: '매년 (0.5)', value: '0.5', id: '1' },
    { label: '매월 (1)', value: '1', id: '2' },
    { label: '매주 (1.5)', value: '1.5', id: '3' },
    { label: '매일 (2.5)', value: '2.5', id: '4' },
    { label: '매시간 (4)', value: '4', id: '5' },
    { label: '지속적으로 (5)', value: '5', id: '6' }
  ];

  FEweightagesVietnameseLang: any[] = [
    { label: 'Hàng năm (0.5)', value: '0.5', id: '1' },
    { label: 'Hàng tháng (1)', value: '1', id: '2' },
    { label: 'Hàng tuần (1.5)', value: '1.5', id: '3' },
    { label: 'Hàng ngày (2.5)', value: '2.5', id: '4' },
    { label: 'Hàng giờ (4)', value: '4', id: '5' },
    { label: 'Liên tục (5)', value: '5', id: '6' }
  ];

  FEweightagesThaiLang: any[] = [
    { label: 'รายปี (0.5)', value: '0.5', id: '1' },
    { label: 'รายเดือน (1)', value: '1', id: '2' },
    { label: 'รายสัปดาห์ (1.5)', value: '1.5', id: '3' },
    { label: 'รายวัน (2.5)', value: '2.5', id: '4' },
    { label: 'รายชั่วโมง (4)', value: '4', id: '5' },
    { label: 'ตลอดเวลา (5)', value: '5', id: '6' }
  ];

  FEweightagesDanishLang: any[] = [
    { label: 'Årligt (0.5)', value: '0.5', id: '1' },
    { label: 'Månedligt (1)', value: '1', id: '2' },
    { label: 'Ugentligt (1.5)', value: '1.5', id: '3' },
    { label: 'Dagligt (2.5)', value: '2.5', id: '4' },
    { label: 'Hver time (4)', value: '4', id: '5' },
    { label: 'Konstant (5)', value: '5', id: '6' }
  ];

  FEweightagesSwedishLang: any[] = [
    { label: 'Årligen (0.5)', value: '0.5', id: '1' },
    { label: 'Månadsvis (1)', value: '1', id: '2' },
    { label: 'Veckovis (1.5)', value: '1.5', id: '3' },
    { label: 'Dagligen (2.5)', value: '2.5', id: '4' },
    { label: 'Varje timme (4)', value: '4', id: '5' },
    { label: 'Ständigt (5)', value: '5', id: '6' }
  ];

   DPEweightagesList: any[] = [
    { label: 'Scratch / Bruise / Excoriation (0.1)', value: '0.1', id: '1' },
    { label: 'Lacerations / Cuts / Mild Illness (0.5)', value: '0.5', id: '2' },
    { label: 'Fracture of Minor Bone(s) / Moderate Illness (1)', value: '1', id: '3' },
    { label: 'Fracture of Major Bone(s) / Serious Illness (2)', value: '2', id: '4' },
    { label: 'Loss of 1 Limb / One Eye (4)', value: '4', id: '5' },
    { label: 'Loss of 2 Limbs / Both Eyes (8)', value: '8', id: '6' },
    { label: 'Permanent or Critical Illness (12)', value: '12', id: '7'},
    { label: 'Fatality (15)', value: '15', id: '8' }
  ];

  DPEweightagesListGermanLng: any[] = [
    { label: 'Kratzer / Prellung / Abschürfung (0.1)', value: '0.1', id: '1' },
    { label: 'Risswunde / Schnitte / Leichte Erkrankung (0.5)', value: '0.5', id: '2' },
    { label: 'Fraktur kleiner Knochen / Mäßige Erkrankung (1)', value: '1', id: '3' },
    { label: 'Fraktur großer Knochen / Schwere Erkrankung (2)', value: '2', id: '4' },
    { label: 'Verlust eines Gliedmaßes / eines Auges (4)', value: '4', id: '5' },
    { label: 'Verlust von zwei Gliedmaßen / beider Augen (8)', value: '8', id: '6' },
    { label: 'Dauerhafte oder kritische Erkrankung (12)', value: '12', id: '7' },
    { label: 'Tödlicher Ausgang (15)', value: '15', id: '8' }
  ];

  DPEweightagesListSpanishLang: any[] =[
      { label: 'Rasguño / Moretón / Excoriación (0.1)', value: '0.1', id: '1' },
      { label: 'Laceración / Cortes / Enfermedad leve (0.5)', value: '0.5', id: '2' },
      { label: 'Fractura de hueso menor / Enfermedad moderada (1)', value: '1', id: '3' },
      { label: 'Fractura de hueso mayor / Enfermedad grave (2)', value: '2', id: '4' },
      { label: 'Pérdida de un miembro / un ojo (4)', value: '4', id: '5' },
      { label: 'Pérdida de dos miembros / ambos ojos (8)', value: '8', id: '6' },
      { label: 'Enfermedad permanente o crítica (12)', value: '12', id: '7' },
      { label: 'Fallecimiento (15)', value: '15', id: '8' }
  ];

  DPEweightagesListPortugueseLang: any[] =[
      { label: 'Arranhão / Contusão / Escoriação (0.1)', value: '0.1', id: '1' },
      { label: 'Laceração / Cortes / Doença leve (0.5)', value: '0.5', id: '2' },
      { label: 'Fratura de osso menor / Doença moderada (1)', value: '1', id: '3' },
      { label: 'Fratura de osso maior / Doença grave (2)', value: '2', id: '4' },
      { label: 'Perda de um membro / um olho (4)', value: '4', id: '5' },
      { label: 'Perda de dois membros / ambos os olhos (8)', value: '8', id: '6' },
      { label: 'Doença permanente ou crítica (12)', value: '12', id: '7' },
      { label: 'Fatalidade (15)', value: '15', id: '8' }
  ];

  DPEweightagesListFrenchLang: any[] =[
    { label: 'Éraflure / Ecchymose / Excoriation (0.1)', value: '0.1', id: '1' },
    { label: 'Lacération / Coupures / Maladie bénigne (0.5)', value: '0.5', id: '2' },
    { label: 'Fracture d’os mineur / Maladie modérée (1)', value: '1', id: '3' },
    { label: 'Fracture d’os majeur / Maladie grave (2)', value: '2', id: '4' },
    { label: 'Perte d’un membre / d’un œil (4)', value: '4', id: '5' },
    { label: 'Perte de deux membres / des deux yeux (8)', value: '8', id: '6' },
    { label: 'Maladie permanente ou critique (12)', value: '12', id: '7' },
    { label: 'Décès (15)', value: '15', id: '8' }
  ];

  DPEweightagesListItalianLang: any[] =[
      { label: 'Graffio / Livido / Escoriazione (0.1)', value: '0.1', id: '1' },
      { label: 'Lacerazione / Tagli / Malattia lieve (0.5)', value: '0.5', id: '2' },
      { label: 'Frattura di osso minore / Malattia moderata (1)', value: '1', id: '3' },
      { label: 'Frattura di osso maggiore / Malattia grave (2)', value: '2', id: '4' },
      { label: 'Perdita di un arto / di un occhio (4)', value: '4', id: '5' },
      { label: 'Perdita di due arti / di entrambi gli occhi (8)', value: '8', id: '6' },
      { label: 'Malattia permanente o critica (12)', value: '12', id: '7' },
      { label: 'Fatalità (15)', value: '15', id: '8' }
  ];

      DPEweightagesListChineseLang: any[] =[
        { label: '擦伤 / 瘀伤 / 表皮擦伤 (0.1)', value: '0.1', id: '1' },
        { label: '撕裂伤 / 割伤 / 轻微疾病 (0.5)', value: '0.5', id: '2' },
        { label: '小骨骨折 / 中度疾病 (1)', value: '1', id: '3' },
        { label: '大骨骨折 / 严重疾病 (2)', value: '2', id: '4' },
        { label: '失去一肢 / 一只眼睛 (4)', value: '4', id: '5' },
        { label: '失去双肢 / 双眼 (8)', value: '8', id: '6' },
        { label: '永久性或危重疾病 (12)', value: '12', id: '7' },
        { label: '死亡 (15)', value: '15', id: '8' }
      ];

      DPEweightagesListPolishLang: any[] =[
        { label: 'Zadrapanie / Stłuczenie / Otarcie (0.1)', value: '0.1', id: '1' },
        { label: 'Rany szarpane / Skaleczenia / Łagodna choroba (0.5)', value: '0.5', id: '2' },
        { label: 'Złamanie drobnych kości / Umiarkowana choroba (1)', value: '1', id: '3' },
        { label: 'Złamanie dużych kości / Poważna choroba (2)', value: '2', id: '4' },
        { label: 'Utrata jednej kończyny / jednego oka (4)', value: '4', id: '5' },
        { label: 'Utrata dwóch kończyn / obu oczu (8)', value: '8', id: '6' },
        { label: 'Trwała lub krytyczna choroba (12)', value: '12', id: '7' },
        { label: 'Śmierć (15)', value: '15', id: '8' }
      ];

      DPEweightagesListDutchLang: any[] =[
        { label: 'Kras / Kneuzing / Schaafwond (0.1)', value: '0.1', id: '1' },
        { label: 'Scheurwonden / Snijwonden / Lichte ziekte (0.5)', value: '0.5', id: '2' },
        { label: 'Breuk van kleine botten / Matige ziekte (1)', value: '1', id: '3' },
        { label: 'Breuk van grote botten / Ernstige ziekte (2)', value: '2', id: '4' },
        { label: 'Verlies van 1 ledemaat / 1 oog (4)', value: '4', id: '5' },
        { label: 'Verlies van 2 ledematen / beide ogen (8)', value: '8', id: '6' },
        { label: 'Blijvende of kritieke ziekte (12)', value: '12', id: '7' },
        { label: 'Dodelijk ongeval (15)', value: '15', id: '8' }
      ];

      DPEweightagesListTurkishLang: any[] =[
        { label: 'Çizik / Morarma / Sıyrık (0.1)', value: '0.1', id: '1' },
        { label: 'Yırtılma / Kesik / Hafif hastalık (0.5)', value: '0.5', id: '2' },
        { label: 'Küçük kemik kırığı / Orta dereceli hastalık (1)', value: '1', id: '3' },
        { label: 'Büyük kemik kırığı / Ciddi hastalık (2)', value: '2', id: '4' },
        { label: '1 uzuv / 1 göz kaybı (4)', value: '4', id: '5' },
        { label: '2 uzuv / iki göz kaybı (8)', value: '8', id: '6' },
        { label: 'Kalıcı veya kritik hastalık (12)', value: '12', id: '7' },
        { label: 'Ölüm (15)', value: '15', id: '8' }
      ];

      DPEweightagesListKoreanLang: any[] =[
        { label: '긁힘 / 멍 / 찰과상 (0.1)', value: '0.1', id: '1' },
        { label: '열상 / 절상 / 경미한 질병 (0.5)', value: '0.5', id: '2' },
        { label: '작은 뼈 골절 / 중간 정도의 질병 (1)', value: '1', id: '3' },
        { label: '큰 뼈 골절 / 심각한 질병 (2)', value: '2', id: '4' },
        { label: '한쪽 팔다리 / 한쪽 눈 상실 (4)', value: '4', id: '5' },
        { label: '양쪽 팔다리 / 양쪽 눈 상실 (8)', value: '8', id: '6' },
        { label: '영구적 또는 위중한 질병 (12)', value: '12', id: '7' },
        { label: '사망 (15)', value: '15', id: '8' }
      ];

      DPEweightagesListVietnameseLang: any[] =[
        { label: 'Trầy xước / Bầm tím / Trầy da (0.1)', value: '0.1', id: '1' },
        { label: 'Rách da / Vết cắt / Bệnh nhẹ (0.5)', value: '0.5', id: '2' },
        { label: 'Gãy xương nhỏ / Bệnh mức trung bình (1)', value: '1', id: '3' },
        { label: 'Gãy xương lớn / Bệnh nghiêm trọng (2)', value: '2', id: '4' },
        { label: 'Mất 1 chi / 1 mắt (4)', value: '4', id: '5' },
        { label: 'Mất 2 chi / cả hai mắt (8)', value: '8', id: '6' },
        { label: 'Bệnh vĩnh viễn hoặc nguy kịch (12)', value: '12', id: '7' },
        { label: 'Tử vong (15)', value: '15', id: '8' }
      ];

      DPEweightagesListThaiLang: any[] =[
        { label: 'รอยขีดข่วน / ฟกช้ำ / แผลถลอก (0.1)', value: '0.1', id: '1' },
        { label: 'แผลฉีกขาด / บาดแผล / การเจ็บป่วยเล็กน้อย (0.5)', value: '0.5', id: '2' },
        { label: 'กระดูกชิ้นเล็กหัก / การเจ็บป่วยปานกลาง (1)', value: '1', id: '3' },
        { label: 'กระดูกชิ้นใหญ่หัก / การเจ็บป่วยร้ายแรง (2)', value: '2', id: '4' },
        { label: 'สูญเสียแขนขา 1 ข้าง / ตา 1 ข้าง (4)', value: '4', id: '5' },
        { label: 'สูญเสียแขนขา 2 ข้าง / ตาทั้งสองข้าง (8)', value: '8', id: '6' },
        { label: 'การเจ็บป่วยถาวรหรือวิกฤต (12)', value: '12', id: '7' },
        { label: 'เสียชีวิต (15)', value: '15', id: '8' }
      ];

      DPEweightagesListDanishLang: any[] =[
        { label: 'Rift / Blå mærke / Hudafskrabning (0.1)', value: '0.1', id: '1' },
        { label: 'Flænger / Snitsår / Mild sygdom (0.5)', value: '0.5', id: '2' },
        { label: 'Brud på mindre knogler / Moderat sygdom (1)', value: '1', id: '3' },
        { label: 'Brud på større knogler / Alvorlig sygdom (2)', value: '2', id: '4' },
        { label: 'Tab af 1 lem / 1 øje (4)', value: '4', id: '5' },
        { label: 'Tab af 2 lemmer / begge øjne (8)', value: '8', id: '6' },
        { label: 'Permanent eller kritisk sygdom (12)', value: '12', id: '7' },
        { label: 'Dødsfald (15)', value: '15', id: '8' }
      ];

      DPEweightagesListSwedishLang: any[] =[
        { label: 'Rivsår / Blåmärke / Skrubbsår (0.1)', value: '0.1', id: '1' },
        { label: 'Sårskador / Skärsår / Mild sjukdom (0.5)', value: '0.5', id: '2' },
        { label: 'Fraktur på mindre ben / Måttlig sjukdom (1)', value: '1', id: '3' },
        { label: 'Fraktur på större ben / Allvarlig sjukdom (2)', value: '2', id: '4' },
        { label: 'Förlust av 1 lem / 1 öga (4)', value: '4', id: '5' },
        { label: 'Förlust av 2 lemmar / båda ögonen (8)', value: '8', id: '6' },
        { label: 'Permanent eller kritisk sjukdom (12)', value: '12', id: '7' },
        { label: 'Dödsfall (15)', value: '15', id: '8' }
      ];

  NPEweightagesList: any[] = [
    { label: '1-2 People (1)', value: '1', id: '1' },
    { label: '3-7 People (2)', value: '2', id: '2' },
    { label: '8-15 People (4)', value: '4', id: '3' },
    { label: '16-50 People (8)', value: '8', id: '4' },
    { label: '>50 People (12)', value: '12', id: '5' }
  ];

  NPEweightagesGermanList: any[] = [
   { "label": "1–2 Personen (1)", "value": "1", "id": "1" },
    { "label": "3–7 Personen (2)", "value": "2", "id": "2" },
    { "label": "8–15 Personen (4)", "value": "4", "id": "3" },
    { "label": "16–50 Personen (8)", "value": "8", "id": "4" },
    { "label": ">50 Personen (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesSpanishList: any[] = [
    { "label": "1–2 personas (1)", "value": "1", "id": "1" },
    { "label": "3–7 personas (2)", "value": "2", "id": "2" },
    { "label": "8–15 personas (4)", "value": "4", "id": "3" },
    { "label": "16–50 personas (8)", "value": "8", "id": "4" },
    { "label": ">50 personas (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesPotugueseList: any[] = [
    { "label": "1–2 pessoas (1)", "value": "1", "id": "1" },
    { "label": "3–7 pessoas (2)", "value": "2", "id": "2" },
    { "label": "8–15 pessoas (4)", "value": "4", "id": "3" },
    { "label": "16–50 pessoas (8)", "value": "8", "id": "4" },
    { "label": ">50 pessoas (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesItalianList: any[] = [
    { "label": "1–2 persone (1)", "value": "1", "id": "1" },
    { "label": "3–7 persone (2)", "value": "2", "id": "2" },
    { "label": "8–15 persone (4)", "value": "4", "id": "3" },
    { "label": "16–50 persone (8)", "value": "8", "id": "4" },
    { "label": ">50 persone (12)", "value": "12", "id": "5" }
  ];

   NPEweightagesFrenchList: any[] = [
    { "label": "1–2 personnes (1)", "value": "1", "id": "1" },
    { "label": "3–7 personnes (2)", "value": "2", "id": "2" },
    { "label": "8–15 personnes (4)", "value": "4", "id": "3" },
    { "label": "16–50 personnes (8)", "value": "8", "id": "4" },
    { "label": ">50 personnes (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesChineseList: any[] = [
    { "label": "1-2 人 (1)", "value": "1", "id": "1" },
    { "label": "3-7 人 (2)", "value": "2", "id": "2" },
    { "label": "8-15 人 (4)", "value": "4", "id": "3" },
    { "label": "16-50 人 (8)", "value": "8", "id": "4" },
    { "label": ">50 人 (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesPolishList: any[] = [
    { "label": "1-2 osoby (1)", "value": "1", "id": "1" },
    { "label": "3-7 osób (2)", "value": "2", "id": "2" },
    { "label": "8-15 osób (4)", "value": "4", "id": "3" },
    { "label": "16-50 osób (8)", "value": "8", "id": "4" },
    { "label": ">50 osób (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesDutchList: any[] = [
    { "label": "1-2 personen (1)", "value": "1", "id": "1" },
    { "label": "3-7 personen (2)", "value": "2", "id": "2" },
    { "label": "8-15 personen (4)", "value": "4", "id": "3" },
    { "label": "16-50 personen (8)", "value": "8", "id": "4" },
    { "label": ">50 personen (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesTurkishList: any[] = [
    { "label": "1-2 kişi (1)", "value": "1", "id": "1" },
    { "label": "3-7 kişi (2)", "value": "2", "id": "2" },
    { "label": "8-15 kişi (4)", "value": "4", "id": "3" },
    { "label": "16-50 kişi (8)", "value": "8", "id": "4" },
    { "label": ">50 kişi (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesKoreanList: any[] = [
    { "label": "1-2명 (1)", "value": "1", "id": "1" },
    { "label": "3-7명 (2)", "value": "2", "id": "2" },
    { "label": "8-15명 (4)", "value": "4", "id": "3" },
    { "label": "16-50명 (8)", "value": "8", "id": "4" },
    { "label": ">50명 (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesVietnameseList: any[] = [
    { "label": "1-2 người (1)", "value": "1", "id": "1" },
    { "label": "3-7 người (2)", "value": "2", "id": "2" },
    { "label": "8-15 người (4)", "value": "4", "id": "3" },
    { "label": "16-50 người (8)", "value": "8", "id": "4" },
    { "label": ">50 người (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesThaiList: any[] = [
    { "label": "1-2 คน (1)", "value": "1", "id": "1" },
    { "label": "3-7 คน (2)", "value": "2", "id": "2" },
    { "label": "8-15 คน (4)", "value": "4", "id": "3" },
    { "label": "16-50 คน (8)", "value": "8", "id": "4" },
    { "label": ">50 คน (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesDanishList: any[] = [
    { "label": "1-2 personer (1)", "value": "1", "id": "1" },
    { "label": "3-7 personer (2)", "value": "2", "id": "2" },
    { "label": "8-15 personer (4)", "value": "4", "id": "3" },
    { "label": "16-50 personer (8)", "value": "8", "id": "4" },
    { "label": ">50 personer (12)", "value": "12", "id": "5" }
  ];

  NPEweightagesSwedishList: any[] = [
    { "label": "1-2 personer (1)", "value": "1", "id": "1" },
    { "label": "3-7 personer (2)", "value": "2", "id": "2" },
    { "label": "8-15 personer (4)", "value": "4", "id": "3" },
    { "label": "16-50 personer (8)", "value": "8", "id": "4" },
    { "label": ">50 personer (12)", "value": "12", "id": "5" }
  ];
  fedExStatusStepperData = [
    { name: 'Opportunity Created', isdone: true },
    { name: 'Quotation Created', isdone: false },
    { name: 'Quotation Approved', isdone: false },
    { name: 'Quotation Sent', isdone: false },
    { name: 'PO Received', isdone: false },
    { name: 'Order Released', isdone: false },
    { name: 'Order Planning', isdone: false },
    { name: 'Order Execution', isdone: false },
    { name: 'Quality Check', isdone: false },
    { name: 'RA Report  Generated', isdone: false }
  ];
  selectedMachineName: string;
  erp_project_id: any;
  customRaodmapsList = [];
  seviceCustomRoadmapsList = [];
  editHazardPayload: any;//{id: '', name: ''}
  erpOfferId: string;
  // Following 3 variables will be used to edit machine via create offer flow
  createOfferIsAnyMachineSelected = false;
  createOfferSelectedMachines: any = [];
  createOfferSelectedMachineIds: any = [];
  selectedLanguage: string = this.languageSupportService.getDefaultLanguage();
  hazardDropdowndata: any[] = [];
  machineModeList: any[] = [];
  machineStatusList: any[] = [];
  sectorIndustryList: any[] = [];
  measureTypes: any[] = [];
  conformityStatus: any[] = [];
  constructor(private graphService: GraphService, private http: HttpClient, public backendService: BackendCallService, public translate: TranslateService, public toastController: ToastController, public modalController: ModalController, public userAuth: UserAuthService,
    private languageSupportService: LanguageSupportService,
    private toastService: ToastService
  ) {
  this.finalNotification = JSON.parse(localStorage.getItem('notificationvalue')) == null ? [] : JSON.parse(localStorage.getItem('notificationvalue'));
  this.notifications$.next(this.finalNotification);
  console.log(this.finalNotification, 'notifications in service constructor');
  }

  getHazardRatingConfig(listName: string, language: string) {
    const normalizedListName = listName === 'Probability of Occurence' ? 'Probability of Occurrence' : listName;
    const resolvedLanguage = ['de', 'sp', 'pt', 'fr', 'it', 'zh', 'pl', 'nl', 'tr', 'ko', 'vi', 'th', 'da', 'sv'].includes(language) ? language : 'en';

    const listNameMappings = {
      'Probability of Occurrence': {
        en: 'Likelihood Of Occurences (LO)',
        de: 'Eintrittswahrscheinlichkeit (LO)',
        sp: 'Probabilidad de ocurrencia (LO)',
        pt: 'Probabilidade de ocorrência (LO)',
        fr: 'Probabilite d\'occurrence (LO)',
        it: 'Probabilita di occorrenza (LO)',
        zh: '发生可能性 (LO)',
        pl: 'Prawdopodobieństwo wystąpienia (LO)',
        nl: 'Waarschijnlijkheid van optreden (LO)',
        tr: 'Gerçekleşme olasılığı (LO)',
        ko: '발생 가능성 (LO)',
        vi: 'Khả năng xảy ra (LO)',
        th: 'โอกาสที่จะเกิดขึ้น (LO)',
        da: 'Sandsynlighed for forekomst (LO)',
        sv: 'Sannolikhet för förekomst (LO)'
      },
      'Frequency of Exposition': {
        en: 'Frequency Of Exposure (FE)',
        de: 'Haufigkeit der Gefahrdung (FE)',
        sp: 'Frecuencia de exposicion (FE)',
        pt: 'Frequencia de exposicao (FE)',
        fr: 'Frequence d\'exposition (FE)',
        it: 'Frequenza di esposizione (FE)',
        zh: '暴露频率 (FE)',
        pl: 'Częstotliwość narażenia (FE)',
        nl: 'Frequentie van blootstelling (FE)',
        tr: 'Maruz kalma sıklığı (FE)',
        ko: '노출 빈도 (FE)',
        vi: 'Tần suất phơi nhiễm (FE)',
        th: 'ความถี่ของการสัมผัส (FE)',
        da: 'Eksponeringshyppighed (FE)',
        sv: 'Exponeringsfrekvens (FE)'
      },
      'Degree of Severity': {
        en: 'Degree Of Possible Harm (DPH)',
        de: 'Schweregrad der Verletzung (DPH)',
        sp: 'Grado de dano posible (DPH)',
        pt: 'Grau de dano possivel (DPH)',
        fr: 'Degre de dommage possible (DPH)',
        it: 'Grado di danno possibile (DPH)',
        zh: '可能伤害程度 (DPH)',
        pl: 'Stopień możliwej szkody (DPH)',
        nl: 'Ernst van mogelijk letsel (DPH)',
        tr: 'Olası zarar derecesi (DPH)',
        ko: '가능한 피해 정도 (DPH)',
        vi: 'Mức độ tổn hại có thể xảy ra (DPH)',
        th: 'ระดับความรุนแรงของอันตรายที่อาจเกิดขึ้น (DPH)',
        da: 'Grad af mulig skade (DPH)',
        sv: 'Grad av möjlig skada (DPH)'
      },
      'Number of Persons Exposed': {
        en: 'Number of Persons at Risk (NPE)',
        de: 'Anzahl der gefahrdeten Personen (NPE)',
        sp: 'Numero de personas en riesgo (NPE)',
        pt: 'Numero de pessoas em risco (NPE)',
        fr: 'Nombre de personnes a risque (NPE)',
        it: 'Numero di persone a rischio (NPE)',
        zh: '暴露人数 (NPE)',
        pl: 'Liczba narażonych osób (NPE)',
        nl: 'Aantal blootgestelde personen (NPE)',
        tr: 'Maruz kalan kişi sayısı (NPE)',
        ko: '노출 인원 수 (NPE)',
        vi: 'Số người bị phơi nhiễm (NPE)',
        th: 'จำนวนผู้ที่สัมผัสความเสี่ยง (NPE)',
        da: 'Antal eksponerede personer (NPE)',
        sv: 'Antal exponerade personer (NPE)'
      }
    };

    const weightageListMappings = {
      'Probability of Occurrence': {
        en: this.weightagesList,
        de: this.weightagesListGermanLng,
        sp: this.weightagesListSpanishLang,
        pt: this.weightagesListPotugueseLang,
        fr: this.weightagesListFrenchLang,
        it: this.weightagesListItalianLang,
        zh: this.weightagesListChineseLang,
        pl: this.weightagesListPolishLang,
        nl: this.weightagesListDutchLang,
        tr: this.weightagesListTurkishLang,
        ko: this.weightagesListKoreanLang,
        vi: this.weightagesListVietnameseLang,
        th: this.weightagesListThaiLang,
        da: this.weightagesListDanishLang,
        sv: this.weightagesListSwedishLang,
      },
      'Frequency of Exposition': {
        en: this.FEweightagesList,
        de: this.FEweightagesGermanLng,
        sp: this.FEweightagesSpanishLang,
        pt: this.FEweightagesPortugueseLang,
        fr: this.FEweightagesFrenchLang,
        it: this.FEweightagesItalianLang,
        zh: this.FEweightagesChineseLang,
        pl: this.FEweightagesPolishLang,
        nl: this.FEweightagesDutchLang,
        tr: this.FEweightagesTurkishLang,
        ko: this.FEweightagesKoreanLang,
        vi: this.FEweightagesVietnameseLang,
        th: this.FEweightagesThaiLang,
        da: this.FEweightagesDanishLang,
        sv: this.FEweightagesSwedishLang,
      },
      'Degree of Severity': {
        en: this.DPEweightagesList,
        de: this.DPEweightagesListGermanLng,
        sp: this.DPEweightagesListSpanishLang,
        pt: this.DPEweightagesListPortugueseLang,
        fr: this.DPEweightagesListFrenchLang,
        it: this.DPEweightagesListItalianLang,
        zh: this.DPEweightagesListChineseLang,
        pl: this.DPEweightagesListPolishLang,
        nl: this.DPEweightagesListDutchLang,
        tr: this.DPEweightagesListTurkishLang,
        ko: this.DPEweightagesListKoreanLang,
        vi: this.DPEweightagesListVietnameseLang,
        th: this.DPEweightagesListThaiLang,
        da: this.DPEweightagesListDanishLang,
        sv: this.DPEweightagesListSwedishLang,
      },
      'Number of Persons Exposed': {
        en: this.NPEweightagesList,
        de: this.NPEweightagesGermanList,
        sp: this.NPEweightagesSpanishList,
        pt: this.NPEweightagesPotugueseList,
        fr: this.NPEweightagesFrenchList,
        it: this.NPEweightagesItalianList,
        zh: this.NPEweightagesChineseList,
        pl: this.NPEweightagesPolishList,
        nl: this.NPEweightagesDutchList,
        tr: this.NPEweightagesTurkishList,
        ko: this.NPEweightagesKoreanList,
        vi: this.NPEweightagesVietnameseList,
        th: this.NPEweightagesThaiList,
        da: this.NPEweightagesDanishList,
        sv: this.NPEweightagesSwedishList,
      }
    };

    return {
      listNameView: listNameMappings[normalizedListName]?.[resolvedLanguage] || listNameMappings[normalizedListName]?.en || normalizedListName,
      weightagesList: weightageListMappings[normalizedListName]?.[resolvedLanguage] || weightageListMappings[normalizedListName]?.en || []
    };
  }

  applyHazardRatingLanguage(hazardRatingList: any[], language: string) {
    hazardRatingList.forEach((item) => {
      const config = this.getHazardRatingConfig(item.listName, language);
      item.listNameView = config.listNameView;
      item.weightagesList = config.weightagesList;
    });

    return hazardRatingList;
  }
  /**
   * Maps dynamic notification data to EnhancedNotificationComponent format
   * @param dynamicNotifications Array of dynamic notifications
   * @returns Array of notifications with title set as 'Blueprint'
   */
public mapToEnhancedNotifications(dynamicNotifications: any[]): any[] {
  if (!Array.isArray(dynamicNotifications)) {
    return [];
  }

  const enhancedNotifications = dynamicNotifications.map(item => ({
    id: Number(item.id),
    title: 'Blueprint',
    text: item.notification || item.text || '',
    isRead: item.read !== undefined ? item.read : !!item.isRead
  }));

  // Log the transformed data before returning
  console.log('Enhanced Notifications:', enhancedNotifications);

  return enhancedNotifications;
}

  /**
   * converting chart months data
   *
   * @param originalData
   * @param projectLegends
   *
   * @returns
   */
  transformChartsMonthsData(originalData: any,projectLegends): any[] {
    const keys= Object.keys(originalData.result);
    const transformedData: any[] = [];
    transformedData.push(projectLegends);
    const weekCount: string[] = [];

    // Extracting all unique keys (dayOfWeek) from the original data
    for (const key in originalData.result) {
      originalData.result[key].forEach((item: any) => {
        if (!weekCount.includes(item.weekCount)) {
          weekCount.push(item.weekCount);
        }
      });
    }

    // Creating rows for each key and populating with respective data or 0 if not found
    weekCount.forEach(eachWeek => {
      const rowData = [eachWeek];
      keys.forEach(key => {
        const data = originalData.result[key].find((item: any) => item.weekCount === eachWeek);
        rowData.push(data ? data.data : 0);
      });
      transformedData.push(rowData);
    });

    return transformedData;
  }

  /**
   * converting chart weeks data
   *
   * @param originalData
   * @param projectLegends
   * @returns
   */
  transformChartsWeeksData(originalData: any,projectLegends): any[] {
   const keys= Object.keys(originalData.result);
    const transformedData: any[] = [];
    transformedData.push(projectLegends);
    const daysOfWeek: string[] = [];

    // Extracting all unique keys (dayOfWeek) from the original data
    for (const key in originalData.result) {
      originalData.result[key].forEach((item: any) => {
        if (!daysOfWeek.includes(item.dayOfWeek)) {
          daysOfWeek.push(item.dayOfWeek);
        }
      });
    }

    // Creating rows for each key and populating with respective data or 0 if not found
    daysOfWeek.forEach(day => {
      const rowData = [day];
      keys.forEach(key => {
        const data = originalData.result[key].find((item: any) => item.dayOfWeek === day);
        rowData.push(data ? data.data : 0);
      });
      transformedData.push(rowData);
    });

    return transformedData;
  }

   /**
    * converting chart Days data
    *
    * @param originalData
    * @param projectLegends
    * @returns
    */
   transformChartsDayData(originalData: any,projectLegends): any[] {
    const keys= Object.keys(originalData.result);
     const transformedData: any[] = [];
     transformedData.push(projectLegends);
     const hours: string[] = [];

     // Extracting all unique keys (Hours) from the original data
     for (const key in originalData.result) {
       originalData.result[key].forEach((item: any) => {
         if (!hours.includes(item.hours)) {
          hours.push(item.hours+1);
         }
       });
     }

     // Creating rows for each key and populating with respective data or 0 if not found
     hours.forEach(hour => {
       const rowData = [hour];
       keys.forEach(key => {
         const data = originalData.result[key].find((item: any) => item.hours === hour);
         rowData.push(data ? data.data : 0);
       });
       transformedData.push(rowData);
     });

     return transformedData;
   }

  updateDashboardCustomizationSubject(data): void {
    this.dashboardCustomizationValueSubmitted.next(data);
  }

  intiazureSearch(searchInput, fullSearch: boolean) {
    let data;
    if (!fullSearch) {
      data = {
        search: searchInput//this.globalSearchInput//this.searchInput
      };
    } else {
      data = {
        queryType: 'full',
        search: searchInput,
        searchMode: 'all'
      };
    }
    this.searchedProjectLists = [];
    this.backendService.azureSearchresults(data).subscribe(
      (response: any) => {
        const lists = [];
        const searchedProject = response.value;
        searchedProject.forEach(_serv => {
          const body = {
            machineName: '',//_mch.machine_name,
            machineType: '',//_mch.machine_type,
            product_id: '',//_srv.product_id,
            customerName: _serv.customer_name,
            projectId: _serv.erp_id,
            no_of_services: _serv?.no_of_services,
            projectManager: _serv.project_manager,
            tempproject_Id: _serv.project_Id
          };
          lists.push(body);
        });
        this.searchedProjectLists = lists;
      });
  }

  getDashboardCustomizationSubjectData(): Observable<{}> {
    return this.dashboardCustomizationValueSubmitted;
  }

  setRoadMapStatusLists(lists = []) {
    this.roadMapStatusLists = lists;
  }

  getRoadMapStatusLists() {
    return this.roadMapStatusLists;
  }

  setServiceRoadMapStatusLists(lists = []) {
    this.roadMapStatusLists = lists;
  }

  getServiceRoadMapStatusLists() {
    return this.roadMapStatusLists;
  }

  initializaCreateBucketList(bucketName, bucketId, projectId, orderId, machineLists = [], serviceId?) {
    const body = {
      bucket_Name: bucketName,
      bucket_Id: bucketId,
      project_Id: projectId,
      order_Id: orderId,
      service_Id: serviceId,
      machine_Id: []
    };
    if (!bucketName) {delete (body.bucket_Name);}
    if (!bucketId) {delete (body.bucket_Id);}
    if (isNotEmptyArray(machineLists)) {body.machine_Id = machineLists;}
    if (!serviceId) {delete body.service_Id;}
    return body;
  }

  initializeAddMachineToExistingBucket(bucketid, machine_ids = []) {
    const body = {
      id: '',
      bucketId: bucketid,
      machineIds: []
    };
    if (isNotEmptyArray(machine_ids)) {
      machine_ids.forEach(_mid => {
        body.machineIds.push(_mid);
      });
    }
    return body;
  }


  /**
   * Create Teams site in Micrsoft SharePoint
   *
   * @param siteData
   */
  async updateSiteDetails(siteData) {
    const data = {
      id: '',
      sitename: siteData.displayName,
      siteid: siteData.id,
      itemid: '',
      driveid: '',
      project_id: '',
      erp_project_id: '',
      created_at: new Date().toISOString(),
      created_by: '',
      modified_at: new Date().toISOString(),
      modified_by: ''
    };
    await this.backendService.updateSiteDetails(data).subscribe((res) => {
    }, err => {
    });
  }

  /**
   * Checking Teams site created in Micrsoft SharePoint
   *
   * @param erp_project_id
   * @param company_code
   */
  checkTeamsSiteExistOrNot(erp_project_id: string, company_code: string) {
    if (erp_project_id && erp_project_id != null && company_code) {
      this.backendService.getSiteDetails(erp_project_id + '_' + company_code).subscribe((res: any) => {
        if (res.length == 0) {
          this.graphService.getGroups().subscribe(async (res: any) => {
            let isExistsTeams: any = {};
            isExistsTeams = res.value.find(element => element.displayName === erp_project_id + '_' + company_code);
            if (isExistsTeams) {
              await this.updateSiteDetails(isExistsTeams);
              this.updateSiteId(res, erp_project_id, company_code);
            }
          });
        } else {
          this.updateSiteId(res, erp_project_id, company_code);
          let isExistsTeams: any = {};
          isExistsTeams = res.find(element => element.sitename === erp_project_id + '_' + company_code);
        }
      }, err => {
        console.log('Error', err);
      });
    }

          // Commented for now
          // if (isExistsTeams && res) {
          //   this.graphService.getUSerByUserPrincipleName().pipe(
          //     switchMap((userRes) => {
          //       if (userRes.id) {
          //         const payload = {
          //           "@odata.id": `https://graph.microsoft.com/v1.0/users/${userRes.id}`
          //         };
          //         return this.graphService.addOwnerToGroup(isExistsTeams.siteid, payload);
          //       }
          //       return of(null); // Return an observable to prevent breaking the chain
          //     }),
          //     catchError((err) => {
          //       console.error('Error:', err); // Handle errors or log them
          //       return of(null); // Return an observable to prevent breaking the chain
          //     })
          //   ).subscribe((addOwnerRes) => {
          //     // Handle the response after adding owner to the group
          //   });
          // }

        // }
      // }, err => {
      //   console.log('Error', err);
      // });
    // }

  }

  async updateSiteId(data, erp_project_id, company_code) {
    if (data) {
      this.graphService.groupId = '';
      this.graphService.siteId = '';
      const siteInfo = data.find(element => element.sitename === erp_project_id + '_' + company_code);
      if (siteInfo && siteInfo.sitename === erp_project_id + '_' + company_code) {
        this.graphService.groupId = siteInfo.siteid;
        try {
          const siteData: any = await this.graphService.getSiteId().toPromise();
          this.graphService.siteId = siteData.parentReference.siteId;
        } catch (error) {
          console.error('Error fetching site ID:', error);
        }
      }
    }
  }



  initialiizeEditBucketInfo(bucketLists, project_Id, order_Id, service_Id, user_Id?, machine_Id = []) {
    const bucket = [];
    if (isNotEmptyArray(bucketLists)) {
      bucketLists.forEach(_bl => {
        const body = {
          bucket_Id: _bl.bucketId,
          bucket_Name: _bl.newTitle || _bl.title,
          project_Id,
          order_Id,
          service_Id
        };
        if (user_Id) {body['user_Id'] = user_Id;}
        bucket.push(body);
      });
    }
    return bucket;
  }

  initializeDeleteBucketInfo(bucketLists) {
    const bucket = [];
    if (isNotEmptyArray(bucketLists)) {
      bucketLists.forEach(_bl => {
        bucket.push(_bl.Bucket_Id);
      });
    }
    return bucket;
  }

  convertToUtcFormat(date) {
    return moment.utc(date).format();
  }

  initializeCreateProject(projectInfo, customerInfo) {
    const body = {
      project_Id: null,
      erp_project_Id: null,
      project_Name: projectInfo.name,
      description: projectInfo.textDescription,
      Start_Date: projectInfo.date,
      end_Date: projectInfo.endDate,
      status: 'Initiated',
      controlling_Area_Code: customerInfo.controlling_area,
      customer_Id: customerInfo.customer_id,
      //company_Code: projectInfo.company_Code,//customerInfo.company_Code,
      company_Code: projectInfo.company_Code.company_code,
      customer_Name: projectInfo.company_Code.customer_name,
      assignedStaff: [],
      customerDetails: {
        customer_Id: customerInfo.customer_id,
        customer_Name: customerInfo.customer_name,
        erp_Customer_Id: customerInfo.erp_customer_id,
        country_Code: customerInfo.country_code,
        city: customerInfo.city,
        zipcode: customerInfo.zipcode,
        street: customerInfo.street,
        phone_Number: customerInfo.phone_number,
        company_Name: customerInfo.company_name,
        controlling_Area_Code: customerInfo.controlling_area_code,
        language: customerInfo.language,
        contacts: customerInfo.contacts
      },
    };
    if (
      isNotNullAndUndefined(customerInfo.assignedStaff) &&
      !isObjectEmpty(customerInfo.assignedStaff)
    ) {
      const _asPayLoad = {
        first_Name: customerInfo.assignedStaff.first_Name,
        last_Name: customerInfo.assignedStaff.last_Name,
        display_Name: customerInfo.assignedStaff.display_Name,
        login_Name: customerInfo.assignedStaff,
        email_Address: customerInfo.assignedStaff.login_Name,
        user_Role: customerInfo.assignedStaff.user_Role,
      };
      body.assignedStaff.push(_asPayLoad);
    }
    return body;
  }

  initializeEditProject(projectId, projectInfo, customerInfo) {
    const body = {
      project_Id: projectId,
      project_Name: projectInfo.projectName,
      project_Description: projectInfo.projectDesc,
      end_Date: projectInfo.endDate,
      start_Date: projectInfo.startDate,
      company_Code: projectInfo.company_Code,
      contacts: [
        {
          contact_Id: customerInfo.selectedContactList.contact_Id,
          erp_Contact_Id: customerInfo.selectedContactList.erp_Contact_Id,
          first_Name: customerInfo.selectedContactList.first_Name,
          last_Name: customerInfo.selectedContactList.last_Name,
          display_Name: customerInfo.selectedContactList.display_Name,
          email_Address: customerInfo.selectedContactList.email_Address,
          title: customerInfo.selectedContactList.title,
          language: customerInfo.selectedContactList.language,
          phone_Number: customerInfo.selectedContactList.phone_Number,
          department: customerInfo.selectedContactList.department
        }
      ]
    };
    return body;
  }

  mapServicesListInfo(list) {
    const body = {
      offerId: list.service.erp_Wbs_Id,
      projectId: list.project.project_Id,
      contactPerson: '',
      companyName: list.project.comapny_Name,
      customerEmail: '',
      customerName: list.project.customerDetails?.customer_Name,
      customerPhoneNumber: '',
      //customerPhoneNumber: list.project.customerDetails?.phone_Number,
      customerAddress: `${list.project.customerDetails?.street},${list.project.customerDetails?.zipcode},${list.project.customerDetails?.city}`,
      customerId: list.project.customerDetails?.customer_Id,
      serviceType: list.service.service_Type,
      serviceLocation: list.service.service_Location,
      serviceStartDate: list.service.start_Date,
      serviceEndDate: list.service.end_Date,
      region: list.service.service_Region,
      serviceDescription: list.service.service_Description,
    };
    if (isNotEmptyArray(list.project.customerDetails?.contacts)) {
      const contactInfo = list.project.customerDetails?.contacts[0];
      body.contactPerson = (contactInfo.first_Name && contactInfo.last_Name) ? contactInfo.first_Name + contactInfo.last_Name : '';
      body.customerEmail = contactInfo.email_Address;
      body.customerPhoneNumber = contactInfo.phone_Number;
    }
    return body;
  }

  initialzeNewUsersToAdd(userLists) {
    const users = [];
    if (isNotEmptyArray(userLists)) {
      userLists.forEach(_ul => {
        const body = {
          id: _ul.Id,
          first_Name: _ul.First_Name,
          last_Name: _ul.Last_Name,
          login_Name: _ul.Login_Name,
          email_Address: _ul.Email_Address
        };
        users.push(body);
      });
    }
    return users;
  }

  initalizeRoleAssignments(roleId, users) {
    const roleAssignmentsInfo = {
      roleId: '',
      users: []
    };
    if (roleId) {roleAssignmentsInfo.roleId = roleId;}
    if (isNotEmptyArray(users)) {
      users.forEach(_us => {
        const body = {
          id: _us.Id,
          first_Name: _us.First_Name,
          last_Name: _us.Last_Name,
          login_Name: _us.Login_Name,
          email_Address: _us.Email_Address
        };
        if (_us.display_Name) {body['display_Name'] = _us.Display_Name;}
        roleAssignmentsInfo.users.push(body);
      });
    }
    return roleAssignmentsInfo;
  }

  initializeRevokeRoleFromUserList(roleid, user) {
    const revokedRoleInfo = {
      roleId: '',
      users: [
        {
          id: user.Id,
          first_Name: user.First_Name,
          last_Name: user.Last_Name,
          display_Name: user.Display_Name,
          login_Name: user.Login_Name,
          email_Address: user.Email_Address
        }
      ]
    };
    if (roleid) {revokedRoleInfo.roleId = roleid;}
    return revokedRoleInfo;
  }

  initializeRaMarkAsComplete(roadmapInfo, level) {
    const markAsCompleteInfo = {
      roadmapId: '',
      serviceMachineId: '',
      maskAsComplete: true
    };
    if (roadmapInfo.id) {markAsCompleteInfo.roadmapId = roadmapInfo.id;}
    if (level == 'machine level' && roadmapInfo.serviceMachineId) {markAsCompleteInfo.serviceMachineId = roadmapInfo.serviceMachineId;}
    if (level == 'service level' && roadmapInfo.serviceId) {markAsCompleteInfo.serviceMachineId = roadmapInfo.serviceId;}

    return markAsCompleteInfo;
  }

  initializeGroupManagementInfoToAdd(groupName, users) {
    const groupListInfo = {
      group_id: '',
      group: {
        id: '',
        group_name: '',
        group_email_address: ''
      },
      users: []
    };
    if (groupName) {groupListInfo.group.group_name = groupName;}
    if (isNotEmptyArray(users)) {
      users.forEach(_us => {
        const body = {
          id: _us.Id,
          first_Name: _us.First_Name,
          last_Name: _us.Last_Name,
          display_Name: _us.Display_Name,
          login_Name: _us.Login_Name,
          email_Address: _us.Email_Address
        };
        groupListInfo.users.push(body);
      });
    }
    return groupListInfo;
  }

  initializeRevokeGroupFromUserList(groupInfo, user) {
    const revokedGroupInfo = {
      group: {
        id: groupInfo.id,
        group_name: groupInfo.group_name,
        group_email_address: groupInfo.group_email_address
      },
      users: [
        {
          id: user.Id,
          first_Name: user.First_Name,
          last_Name: user.Last_Name,
          display_Name: user.Display_Name,
          login_Name: user.Login_Name,
          email_Address: user.Email_Address
        }
      ]
    };
    return revokedGroupInfo;
  }

  intitializeEditGroupInfo(groupName, groupId, groupEmail?) {
    const editPayload = {
      id: '',
      group_name: '',
      group_email_address: ''
    };
    if (groupName) {editPayload.group_name = groupName;}
    if (groupId) {editPayload.id = groupId;}
    if (groupEmail) {editPayload.group_email_address = groupEmail;}
    return editPayload;
  }

  intitializeEditAllRoleInfo(roleName, roleId) {
    const editAllRoleInfo = {
      id: '',
      role_name: '',
      isDefault: true,
      isGlobalAdminRole: false
    };
    const user = this.userAuth.getUserList();
    if (user && user.isGlobalAdmin) {editAllRoleInfo.isGlobalAdminRole = user.isGlobalAdmin;}
    if (roleName) {editAllRoleInfo.role_name = roleName;}
    if (roleId) {editAllRoleInfo.id = roleId;}
    return editAllRoleInfo;
  }

  initializeAddUsersInGroup(groupId, groupName, users) {
    const groupListInfo = {
      group: {
        id: '',
        group_name: '',
        group_email_address: ''
      },
      users: []
    };
    if (groupId) {groupListInfo.group.id = groupId;}
    if (groupName) {groupListInfo.group.group_name = groupName;}
    if (isNotEmptyArray(users)) {
      users.forEach(_us => {
        const body = {
          id: _us.Id,
          first_Name: _us.First_Name,
          last_Name: _us.Last_Name,
          display_Name: _us.Display_Name,
          login_Name: _us.Login_Name,
          email_Address: _us.Email_Address
        };
        groupListInfo.users.push(body);
      });
    }
    return groupListInfo;
  }

  constructLogActualHoursLists(machineListInfo) {
    const logActualHoursInfo = [];
    if (isNotEmptyArray(machineListInfo)) {
      machineListInfo.forEach(_ml => {
        const body = {
          open: false,
          edit: false,
          machine_Id: _ml.machine_Id,
          machinename: _ml.machine_Name,
          machine_id: _ml.machine_Id,
          serialNo: _ml.serial_Number,
          assetNo: _ml.asset_Id,
          calculatedHours: _ml.calculatedHours ? _ml.calculatedHours : 0,
          // calculatedHours: _ml.logActualHours ? _ml.logActualHours.calculatedHours : 0,
          comments: _ml.logActualHours ? _ml.logActualHours.comments : '',
          aggregateHours: _ml.aggregatedHours ? _ml.aggregatedHours : 0,
          serviceMachineId: _ml.serviceMachine_Id?.serviceMachineId ? _ml.serviceMachine_Id?.serviceMachineId : ''
        };
        logActualHoursInfo.push(body);
      });
    }
    return logActualHoursInfo;
  }

  initializeLogActualHours(projectId, orderid, serviceid, logActualHoursMachineLists, type) {
    const logActualHoursInfo = {
      project_Id: '',
      order_Id: '',
      service_Id: '',
      serviceMachine_Id: '',
      user_Id: '',
      user_Name: '',
      machineActualHours: []
    };
    const user = this.userAuth.getUserList();
    if (projectId) {logActualHoursInfo.project_Id = projectId;}
    if (orderid) {logActualHoursInfo.order_Id = orderid;}
    if (serviceid) {logActualHoursInfo.service_Id = serviceid;}
    if (user && user.userId) {
      logActualHoursInfo.user_Id = user.userId;
      logActualHoursInfo.user_Name = user.name;
    }
    if (isNotEmptyArray(logActualHoursMachineLists) && user && user.userId) {
      logActualHoursMachineLists.forEach(_lahl => {
        const machineActHrsBody = {
          serviceMachine_Id: '',
          machine_Id: '',
          actualHours: 0,
          comments: '',
          action: type
        };
        machineActHrsBody.serviceMachine_Id = _lahl.serviceMachine_Id;
        machineActHrsBody.machine_Id = _lahl.machine_id;
        if (_lahl.newActualHours) {machineActHrsBody.actualHours = +_lahl.newActualHours;}
        if (_lahl.newComments) {machineActHrsBody.comments = _lahl.newComments;}
        logActualHoursInfo.machineActualHours.push(machineActHrsBody);
      });
    }
    return logActualHoursInfo;
  }

  initializeResolvedConflictResolution(machinesLists, roadmapLists) {
    const body = {
      machine_Id: machinesLists.machine_Id,
      machine_Name: machinesLists.machine_Name,
      asset_Id: machinesLists.asset_Id,
      machine_Type: machinesLists.masterMachine ? machinesLists.masterMachine.machine_Type : '',
      industry: machinesLists.industry,
      masterMachine_Id: machinesLists.masterMachine_Id,
      serial_Number: machinesLists.serial_Number,
      service_Machine_Id: machinesLists.service_Machine_Id,
      roadmapDetails: [],
      isMachineConflict: false
    };
    if (isNotEmptyArray(roadmapLists)) {
      roadmapLists.forEach(_rml => {
        if (_rml.isConflict) {
          _rml.isMachineConflict = true;
        }
        delete _rml.eachQuesAnswered;
      });
      body.roadmapDetails = roadmapLists;
    }
    return body;
  }

  initializeRequestedFourEyeInformation(serviceMachineId, selectedUserId, hazardsInfo = []) {
    const body = {
      serviceMachine_Id: serviceMachineId,
      reviewer: '',
      hazards: []
    };
    if (selectedUserId) {body.reviewer = selectedUserId;}
    if (isNotEmptyArray(hazardsInfo)) {body.hazards = hazardsInfo;}
    return body;
  }

  async initializeFourEyeQualityMarkAsCompleteInformation(serviceMachine_Id) {
    const user = await this.userAuth.getUserList();
    const body = {
      markAsComplete: true,
      userId: user.userId,
      serviceMachine_Id,
    };
    return body;
  }

  initializeCustomRoadmapInfo(roadmapLists) {
    const roadmapInfo = [];
    if (isNotEmptyArray(roadmapLists)) {
      roadmapLists.forEach(_rmp => {
        const rPayload = {
          roadMapName: _rmp,
          roadMapVersion: '',
          description: '',
          isCustom: true
        };
        roadmapInfo.push(rPayload);
      });
    }
    return roadmapInfo;
  }

  initializeEditFourEyeHazardLists(recommendedCategory, 
    hazardid, 
    hazardInfo, 
    machineModeList,
    RiskResassessmentMachineMode, 
    riskMachineModesWithIds, 
    machinemodesWithIds, 
    hazardRatingList, 
    addHazardInfo, 
    hazardImagesList, 
    hazardSourceConnsequencesData,
    hazardDetailsData) {
    const hazardPayload = {
      id: hazardid,
      name: hazardInfo.hazardName,
      hazard_type_id: hazardid,
      initial_hazard: hazardInfo?.pickInitialHazard ? hazardInfo?.pickInitialHazard : hazardDetailsData?.pickInitialHazard,
      counter_measure: hazardInfo?.pickControlMeasure ? hazardInfo?.pickControlMeasure : hazardDetailsData?.pickControlMeasure,
      service_machine_steps_id: '',
      notes: hazardInfo?.notes ? hazardInfo?.notes : '',
      version: '',
      plr: hazardInfo?.determinePlrValue,
      category: recommendedCategory,
      hazardType: [],
      hazardMedia: hazardImagesList,
      hrnCalculations: [],
      plrObj: hazardDetailsData.plrObj
    };
    // Object.entries(hazardInfo.hazardTypesData).forEach((item, index) => {
    //   let hrnList = item[1];
    //   hazardTypeList.push(hrnList)
    // })
    if (isNotEmptyArray(addHazardInfo)) {
      addHazardInfo.forEach(_ahi => {
        const payload = {
          hazardTypeId: '',
          hazardTypeName: '',
          hazardSources: [],
          hazardConsequences: []
        };
        payload.hazardTypeId = _ahi?.hazardTypeId;
        payload.hazardTypeName = _ahi?.hazardType?.hazardTypeName;
        if (isNotEmptyArray(_ahi.source)) {
          if (hazardSourceConnsequencesData[0].source.length) {
            _ahi.source.forEach((_hs) => {
              const hazardSource = {
                id: '',
                source: ''
              };
              hazardSource.source = _hs?.source;
              hazardSourceConnsequencesData[0].source.forEach((src) => {
                if (src.source == _hs?.source) {
                  hazardSource.id = src.hazardSourceId;
                }
              });
              payload.hazardSources.push(hazardSource);
            });

          } else {
            _ahi.source.forEach((_hs) => {
              const hazardSource = {
                id: '',
                source: ''
              };
              hazardSource.source = _hs?.source;
              if (_hs.id) {hazardSource.id = _hs?.hazardSourceId;}
              payload.hazardSources.push(hazardSource);
            });
          }
        }
        if (isNotEmptyArray(_ahi.consequences)) {
          if (hazardSourceConnsequencesData[0].consequences.length) {
            _ahi.consequences.forEach(_hc => {
              const hazardConsequence = {
                id: '',
                consequences: ''
              };
              hazardConsequence.consequences = _hc?.consequence;
              hazardSourceConnsequencesData[0].consequences.forEach((consequence) => {
                if (consequence.consequence == _hc?.consequence) {
                  hazardConsequence.id = consequence.hazardConsequenceId;
                }
              });
              payload.hazardConsequences.push(hazardConsequence);
            });

          } else {
            _ahi.consequences.forEach(_hc => {
              const hazardConsequence = {
                id: '',
                consequences: ''
              };
              if (_hc.id) {hazardConsequence.id = _hc?.hazardConsequenceId;}
              hazardConsequence.consequences = _hc?.consequence;
              payload.hazardConsequences.push(hazardConsequence);
            });
          }

        }
        hazardPayload.hazardType.push(payload);
      });
    }
    if (isNotEmptyArray(RiskResassessmentMachineMode)) {
      const currentHrnPayload = {
        type: 'Risk Reassessment Current',
        values: []
      };
      const indicativeHrnPayload = {
        type: 'Risk Reassessment Indicative',
        values: []
      };
      RiskResassessmentMachineMode.forEach(_mm => {
        const _riskchrnValue = {
          id: '',
          po: '',
          sd: '',
          fe: '',
          np: '',
          rating: '',
          version: '',
          mode: ''
        };
        const _riskihrnValue = {
          id: '',
          po: '',
          sd: '',
          fe: '',
          np: '',
          rating: '',
          version: '',
          mode: ''
        };
        let iRating = 1;
        let cRating = 1;
        _riskchrnValue.mode = _mm;
        _riskihrnValue.mode = _mm;
        hazardRatingList.forEach(_hrl => {
          // const matchedChrnIds = machinemodesWithIds.find(_mmwi => { return _mmwi.mode == _mm && _mmwi.type == 'Current' })
          if (_hrl.dataRiskChrn) {//&& matchedChrnIds && matchedChrnIds.id
            Object.entries(_hrl.dataRiskChrn).forEach((item, index) => {
              if (item[0] == _mm) {
                const matchedChrnIds = riskMachineModesWithIds.find(_mmwi => _mmwi.mode == _mm && _mmwi.type == 'Risk Reassessment Current');
                // if (matchedChrnIds && matchedChrnIds.id) _chrnValue.id = matchedChrnIds.id
                if (matchedChrnIds && matchedChrnIds.id) {
                  _riskchrnValue.id = matchedChrnIds.id;
                } else {
                  _riskchrnValue.id = null;
                }
                // _chrnValue.mode = _mm;
                if (_hrl.val == 'PO') {
                  _riskchrnValue.po = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;
                }
                if (_hrl.val == 'SD') {
                  _riskchrnValue.sd = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'NP') {
                  _riskchrnValue.np = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'FE') {
                  _riskchrnValue.fe = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                _riskchrnValue.rating = JSON.stringify(cRating);
              }
            });
          }
          // const matchedIhrnIds = machinemodesWithIds.find(_mmwi => { return _mmwi.mode == _mm && _mmwi.type == 'Indicative' })
          if (_hrl.dataRiskIhrn) {//&& matchedIhrnIds && matchedIhrnIds.id
            Object.entries(_hrl.dataRiskIhrn).forEach((item, index) => {
              if (item[0] == _mm) {
                const matchedIhrnIds = riskMachineModesWithIds.find(_mmwi => _mmwi.mode == _mm && _mmwi.type == 'Risk Reassessment Indicative');
                // if (matchedIhrnIds && matchedIhrnIds.id) _ihrnValue.id = matchedIhrnIds.id
                if (matchedIhrnIds && matchedIhrnIds.id) {
                  _riskihrnValue.id = matchedIhrnIds.id;
                } else {
                  _riskihrnValue.id = null;
                }
                if (_hrl.val == 'PO') {
                  _riskihrnValue.po = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);
                }
                if (_hrl.val == 'SD') {
                  _riskihrnValue.sd = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'NP') {
                  _riskihrnValue.np = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'FE') {
                  _riskihrnValue.fe = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                _riskihrnValue.rating = JSON.stringify(iRating);
              }
            });
          }
        });
        currentHrnPayload.values.push(_riskchrnValue);
        indicativeHrnPayload.values.push(_riskihrnValue);
      });
      hazardPayload.hrnCalculations.push(currentHrnPayload);
      hazardPayload.hrnCalculations.push(indicativeHrnPayload);
    }
    if (isNotEmptyArray(machineModeList)) {
      const currentHrnPayload = {
        type: 'Current',
        values: []
      };
      const indicativeHrnPayload = {
        type: 'Indicative',
        values: []
      };
      machineModeList.forEach(_mm => {
        const _chrnValue = {
          id: '',
          po: '',
          sd: '',
          fe: '',
          np: '',
          rating: '',
          version: '',
          mode: ''
        };
        const _ihrnValue = {
          id: '',
          po: '',
          sd: '',
          fe: '',
          np: '',
          rating: '',
          version: '',
          mode: ''
        };
        let iRating = 1;
        let cRating = 1;
        _chrnValue.mode = _mm;
        _ihrnValue.mode = _mm;
        hazardRatingList.forEach(_hrl => {
          // const matchedChrnIds = machinemodesWithIds.find(_mmwi => { return _mmwi.mode == _mm && _mmwi.type == 'Current' })
          if (_hrl.dataChrn) {//&& matchedChrnIds && matchedChrnIds.id
            Object.entries(_hrl.dataChrn).forEach((item, index) => {
              if (item[0] == _mm) {
                const matchedChrnIds = machinemodesWithIds.find(_mmwi => _mmwi.mode == _mm && _mmwi.type == 'Current');
                // if (matchedChrnIds && matchedChrnIds.id) _chrnValue.id = matchedChrnIds.id
                if (matchedChrnIds && matchedChrnIds.id) {
                  _chrnValue.id = matchedChrnIds.id;
                } else {
                  _chrnValue.id = null;
                }
                // _chrnValue.mode = _mm;
                if (_hrl.val == 'PO') {
                  _chrnValue.po = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;
                }
                if (_hrl.val == 'SD') {
                  _chrnValue.sd = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'NP') {
                  _chrnValue.np = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'FE') {
                  _chrnValue.fe = item[1]['id']
                  cRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                _chrnValue.rating = JSON.stringify(cRating);
              }
            });
          }
          // const matchedIhrnIds = machinemodesWithIds.find(_mmwi => { return _mmwi.mode == _mm && _mmwi.type == 'Indicative' })
          if (_hrl.dataIhrn) {//&& matchedIhrnIds && matchedIhrnIds.id
            Object.entries(_hrl.dataIhrn).forEach((item, index) => {
              if (item[0] == _mm) {
                const matchedIhrnIds = machinemodesWithIds.find(_mmwi => _mmwi.mode == _mm && _mmwi.type == 'Indicative');
                // if (matchedIhrnIds && matchedIhrnIds.id) _ihrnValue.id = matchedIhrnIds.id
                if (matchedIhrnIds && matchedIhrnIds.id) {
                  _ihrnValue.id = matchedIhrnIds.id;
                } else {
                  _ihrnValue.id = null;
                }
                if (_hrl.val == 'PO') {
                  _ihrnValue.po = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);
                }
                if (_hrl.val == 'SD') {
                  _ihrnValue.sd = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'NP') {
                  _ihrnValue.np = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                if (_hrl.val == 'FE') {
                  _ihrnValue.fe = item[1]['id']
                  iRating *= item[1]['value'] ? JSON.parse(item[1]['value']) : 0;//JSON.parse(item[1]['value']);

                }
                _ihrnValue.rating = JSON.stringify(iRating);
              }
            });
          }
        });
        currentHrnPayload.values.push(_chrnValue);
        indicativeHrnPayload.values.push(_ihrnValue);
      });
      hazardPayload.hrnCalculations.push(currentHrnPayload);
      hazardPayload.hrnCalculations.push(indicativeHrnPayload);
    }
    return hazardPayload;
  }

  async showToast(toastTitle?: string, toastMessage?: string) {
    const toast = await this.toastController.create({
      header: toastTitle,
      message: toastMessage,
      cssClass: 'my-custom-toast',
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  async showWarningToast(toastTitle: string, toastMessage: string) {
    const toast = await this.toastController.create({
      header: toastTitle,
      message: toastMessage,
      cssClass: 'my-custom-toast',
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }
  async errorShowToast(toastTitle?: string, toastMessage?: string) {
    const toast = await this.toastController.create({
      header: toastTitle,
      message: toastMessage,
      cssClass: 'my-custom-error-toast',
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  async closeBox() {
    const props = {
      isOfferCreation: true,
    };
    let msg: string;
    this.translate.get(AppConstants.ARE_YOU_SURE_TO_CANCEL).subscribe(res => {
      msg = res;
    });
    props['alertContent'] = msg;
    const modal = await this.modalController.create({
      component: AlertModalPage,
      cssClass: 'small-alert-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: props,
    });
    await modal.present();
    const {
      // data: { isOfferCreationConfirmClose },
    } = await modal.onWillDismiss();
    // if (isOfferCreationConfirmClose) this.goBack();
  }


  compress(file: File): Observable<File> {
    // in bytes, compress images larger than 1MB
    const fileSizeMax = 1 * 1024 * 1024;
    // in pixels, compress images have the width or height larger than 1024px
    const widthHeightMax = 1024;
    const defaultWidthHeightRatio = 1;
    const defaultQualityRatio = 0.7;
    const imageType = file.type || 'image/jpeg';
    const reader = new FileReader();
    reader.readAsDataURL(file);

    return Observable.create(observer => {
      // This event is triggered each time the reading operation is successfully completed.
      reader.onload = ev => {
        // Create an html image element
        const img = this.createImage(ev);
        // Choose the side (width or height) that longer than the other
        const imgWH = img.width > img.height ? img.width : img.height;

        // Determines the ratios to compress the image
        const withHeightRatio = (imgWH > widthHeightMax) ? widthHeightMax / imgWH : defaultWidthHeightRatio;
        const qualityRatio = (file.size > fileSizeMax) ? fileSizeMax / file.size : defaultQualityRatio;

        // Fires immediately after the browser loads the object
        img.onload = () => {
          const elem = document.createElement('canvas');
          // resize width, height
          elem.width = img.width * withHeightRatio;
          elem.height = img.height * withHeightRatio;

          const ctx = <CanvasRenderingContext2D>elem.getContext('2d');
          ctx.drawImage(img, 0, 0, elem.width, elem.height);
          ctx.canvas.toBlob(
            // callback, called when blob created
            blob => {
              observer.next(new File(
                [blob],
                file.name,
                {
                  type: imageType,
                  lastModified: Date.now(),
                }
              ));
            },
            imageType,
            qualityRatio, // reduce image quantity
          );
        };
      };

      // Catch errors when reading file
      reader.onerror = error => observer.error(error);
    });
  }

  private createImage(ev) {
    const imageContent = ev.target.result;
    const img = new Image();
    img.src = imageContent;
    return img;
  }

  async uploadChunks(file, uploadUrl) {
    const reader = new FileReader();
    // Variables for byte stream position
    let position = 0;
    const chunkLength = 320 * 1024;
    let continueRead = true;
    while (continueRead) {
      var chunk;
      try {
        continueRead = true;
        //Try to read in the chunk
        try {
          const stopB = position + chunkLength;
          console.log('Sending Asynchronous request to read in chunk bytes from position ' + position + ' to end ' + stopB);
          chunk = await this.readFragmentAsync(file, position, stopB);
          console.log('UploadChunks: Chunk read in of ' + chunk.byteLength + ' bytes.');
          if (chunk.byteLength > 0) {
            continueRead = true;
          } else {
            break;
          }
          console.log('Chunk bytes received = ' + chunk.byteLength);
        } catch (e) {
          console.log('Bytes Received from readFragmentAsync:: ' + e);
          break;
        }
        // Try to upload the chunk.
        try {
          console.log('Request sent for uploadFragmentAsync');
          const res = await this.uploadChunk(chunk, uploadUrl, position, file.size);
          console.log('Response from uploadChunk', res);
          // Check the response.
          if (res[0] != 202 && res[0] != 201 && res[0] != 200)
            {throw ('Put operation did not return expected response');}
          if (res[0] === 201 || res[0] === 200) {
            console.log('Reached last chunk of file.  Status code is: ' + res[0]);
            continueRead = false;
            return res;
          }
          else {
            console.log('Continuing - Status Code is: ' + res[0]);
            position = Number(res[1].nextExpectedRanges[0].split('-')[0]);
          }

          console.log('Response received from uploadChunk.');
          console.log('Position is now ' + position);

        } catch (e) {
          console.log('Error occured when calling uploadChunk::' + e);
        }
        //
      } catch (e) {
        continueRead = false;
      }
    }
  }
  // Reads in the chunck and returns a promise.
  readFragmentAsync(file, startB, stopB) {
    let frag;
    const reader = new FileReader();
    console.log('startBytes :' + startB + ' stopBytes :' + stopB, file.slice(startB, stopB));
    const blob = file.slice(startB, stopB);
    reader.readAsArrayBuffer(blob);
    return new Promise((resolve, reject) => {
      reader.onloadend = (event) => {
        if (reader.readyState == reader.DONE) {
          frag = reader.result;
          resolve(frag);
        }
      };
    });
  }

  // Upload each chunk using PUT
  uploadChunk(chunk, uploadURL, position, totalLength) {//: Observable<any> {
    const max = position + chunk.byteLength - 1;
    // let contentLength = position + chunk.byteLength;
    const crHeader = `bytes ${position}-${max}/${totalLength}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Range': crHeader,
      })
    };
    // return this.http.put(uploadURL, chunk,httpOptions)

    return new Promise((resolve, reject) => {
      try {
        const crHeader = `bytes ${position}-${max}/${totalLength}`;
        this.http
          .put(uploadURL, chunk, httpOptions).subscribe((res: any) => {
            if (res.nextExpectedRanges && res.nextExpectedRanges.length) {
              resolve([202, res]);
            } else if (res.webUrl && res?.webUrl) {
              resolve([201, res]);
            } else {
              resolve([201, res]);
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Get Countries
   */
  public getCountry() {
    const _self = this;
    _self.backendService
      .getCountry()
      .then((data: any) => {
        this.countryData = data.response;
        localStorage.setItem('countryData', JSON.stringify(data.response));
        this.countryList = data.response.map(item => ({ label: item.country_name, value: item.country_name }));
        return this.countryList;
      });
  }

  /**
   * To get the formData of imageFiles
   * @param files
   * @param file_path
   * @returns 
   */
  public prepareImageFormData(formData, files, file_path): FormData {
    files.forEach(file => {
      formData.append('file_list', file);
      formData.append('file_path', file_path);
    });
    return formData;
  }

  /**
   * To get the formData of thumbnail image
   * @param files 
   * @param thumbnailPath 
   * @returns 
   */
  public prepareThumbnailFormData(formData , files: File[], thumbnailPath: string): Promise<FormData> {
    const thumbnailPromises = files.map(file => 
      this.getThumbnailUrl(file, 800, 800)
        .then(thumbnailUrl => {
          if (thumbnailUrl) {
            return this.urlToFile(thumbnailUrl, file.name, file.type)
              .then(thumbnailFile => {
                // Append each thumbnail file to the FormData
                formData.append('file_list', thumbnailFile, thumbnailFile.name);
                formData.append('file_path', thumbnailPath);
                return thumbnailFile;
              });
          }
        })
        .catch(error => {
          console.error('Error generating thumbnail:', error);
        })
    );
  
    return Promise.all(thumbnailPromises)
      .then(() => {
        
        return formData;
      });
  }

  /**
   * To get the file object from url
   * @param url 
   * @param filename 
   * @param mimeType 
   * @returns 
   */
  private urlToFile(url: string, filename: string, mimeType: string): Promise<File> {
    return fetch(url)
      .then(response => response.blob())
      .then(blob => {
        return new File([blob], filename, { type: mimeType });
      });
  }

  /**
   * To get thumbnailUrl as per passed file, maxWidth and maxHeight
   * @param file 
   * @param maxWidth 
   * @param maxHeight 
   * @returns 
   */
  public getThumbnailUrl(file: File, maxWidth: number, maxHeight: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!file.type.startsWith('image/')) {
        reject('File is not an image.');
        return;
      }
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          const thumbnailUrl = canvas.toDataURL('image/png');
          resolve(thumbnailUrl);
        };
        img.src = event.target.result;
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  getHazardDropdownData() {
    this.selectedLanguage = this.languageSupportService.getDefaultLanguage();
    const requestLanguage = this.selectedLanguage;

    this.translate.use(this.selectedLanguage).subscribe(() => {
      this.backendService.gethazarddropdowndata(requestLanguage).subscribe((data: any) => {
        if ((data.statusCode === 200)) {
          this.hazardDropdowndata = data.response.map(hazardType => ({
            ...hazardType,
            hazardTypeId: hazardType.hazardTypeId === null || hazardType.hazardTypeId === undefined ? '' : String(hazardType.hazardTypeId),
            hazardTypeName: this.translate.instant(hazardType.hazardTypeName),
            hazardConsequences: hazardType.hazardConsequences.map(consequence => ({
                hazardTypeId: consequence.hazardTypeId === null || consequence.hazardTypeId === undefined ? '' : String(consequence.hazardTypeId),
                hazardConsequenceId: consequence.hazardConsequenceId === null || consequence.hazardConsequenceId === undefined ? '' : String(consequence.hazardConsequenceId),
                consequences: this.translate.instant(consequence.hazardConsequenceName),
                consequence: this.translate.instant(consequence.hazardConsequenceName)
            })),
            hazardSources: hazardType.hazardSources.map(source => ({
                hazardTypeId: source.hazardTypeId === null || source.hazardTypeId === undefined ? '' : String(source.hazardTypeId),
                hazardSourceId: source.hazardSourceId === null || source.hazardSourceId === undefined ? '' : String(source.hazardSourceId),
                source: this.translate.instant(source.hazardSourceName)
            }))
          }));
          this.hazardDropdownData$.next(this.hazardDropdowndata);
        } else {
          this.toastService.presentToast(data.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      }, err => {
        this.hazardDropdownData$.next([]);
        this.toastService.presentToast(this.translate.instant('no_data_found_for_hazard'), 3000, AppConstants.ERROR_SNACKBAR, 'top');
      });
    });
  }

  getControlMeasureType() {
    this.selectedLanguage = this.languageSupportService.getDefaultLanguage();
    this.backendService.getcontrolmeasuretype(this.selectedLanguage).subscribe((data: any) => {
      if ((data.statusCode === 200)) {
        this.measureTypes = data.response;
      } else {
        this.toastService.presentToast(data.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    }, err => {
      console.log(err)
    })
  }

  getConformityStatus() {
    this.backendService.getConformityStatus().subscribe((data: any) => {
      if ((data.statusCode == 200)) {
        this.conformityStatus = data.response;
        console.log("this.conformityStatus", this.conformityStatus)
      } else {
        this.toastService.presentToast(data.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    }, err => {
      console.log(err)
    })
  }

  getMachineModes() {
    this.selectedLanguage = this.languageSupportService.getDefaultLanguage();
    this.backendService.getMachineModes(this.selectedLanguage).subscribe((data: any) => {
      if ((data.statusCode === 200)) {
        this.machineModeList = this.translateNotAvailableOptions(data?.response?.modes);
        this.machineStatusList = this.translateNotAvailableOptions(data?.response?.machineStatus);
      } else {
        this.toastService.presentToast(data.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 3000, AppConstants.ERROR_SNACKBAR, 'top');
    })
  }

  getSectorIndustry() {
    this.selectedLanguage = this.languageSupportService.getDefaultLanguage();
    this.backendService.getSectorIndustry(this.selectedLanguage).subscribe((data: any) => {
      if ((data.statusCode === 200)) {
        this.sectorIndustryList = this.translateNotAvailableOptions(data?.response);
      } else {
        this.toastService.presentToast(data.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 3000, AppConstants.ERROR_SNACKBAR, 'top');
    })
  }

  private translateNotAvailableOptions(options: any[] = []): any[] {
    return options.map(option => {
      if (!option || typeof option !== 'object') {
        return option;
      }

      return {
        ...option,
        name: option.name === 'Not Available' ? this.translate.instant('not_available') : option.name,
      };
    });
  }

}